import React from 'react';
import { CSSObject } from '@emotion/react';
import { MoodThemeProvider } from '@components/blocks/BlockThemeProvider';

interface FixedFooterWrapperProps {
  children: React.ReactNode;
}

const useStyles = (): Record<string, CSSObject> => ({
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%'
  }
});

export function FixedFooterWrapper({ children }: FixedFooterWrapperProps): JSX.Element {
  const { stickyFooter } = useStyles();

  return (
    <div css={stickyFooter}>
      <MoodThemeProvider>{children}</MoodThemeProvider>
    </div>
  );
}

export default FixedFooterWrapper;
